import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { allProjects } from '../data/projects';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';

const PortfolioPage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const categories = [
    { id: 'all', name: 'All Projects' },
    { id: 'website', name: 'Website Development' },
    { id: 'ecommerce', name: 'E-commerce' },
    { id: 'mobile', name: 'Mobile Apps' },
    { id: 'system', name: 'Custom Systems' },
    { id: 'mlm', name: 'MLM / Blockchain' }
  ];

  const filteredProjects = selectedCategory === 'all' 
    ? allProjects 
    : allProjects.filter(project => project.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Our Portfolio
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Real projects delivering real business results for our clients
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-2 rounded-full font-medium transition-colors ${
                  selectedCategory === category.id
                    ? 'bg-gray-900 text-white'
                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <div key={project.id} className="bg-white rounded-lg overflow-hidden shadow-sm border border-gray-200 hover:shadow-lg transition-shadow">
                <div className="aspect-w-16 aspect-h-9 bg-gray-100">
                  <img 
                    src={project.screenshots[0]} 
                    alt={project.title}
                    className="w-full h-48 object-cover object-top"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = '/projects/placeholder.jpg';
                    }}
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-black font-medium capitalize">
                      {project.category}
                    </span>
                    <span className="text-sm text-black">
                      {project.industry}
                    </span>
                  </div>
                  <h3 className="text-xl font-semibold text-black mb-2">
                    {project.title}
                  </h3>
                  <p className="text-black mb-4">
                    <strong>Client:</strong> {project.client}
                  </p>
                  <div className="mb-4">
                    <h4 className="font-semibold text-black mb-2">Challenge</h4>
                    <p className="text-black text-sm">{project.challenge}</p>
                  </div>
                  <div className="mb-4">
                    <h4 className="font-semibold text-black mb-2">Solution</h4>
                    <p className="text-black text-sm">{project.solution}</p>
                  </div>
                  <div className="mb-4">
                    <h4 className="font-semibold text-black mb-2">Impact</h4>
                    <p className="text-black text-sm">{project.impact}</p>
                  </div>
                  {project.metrics && (
                    <div className="mb-4">
                      <h4 className="font-semibold text-black mb-2">Results</h4>
                      <div className="flex flex-wrap gap-2">
                        {Object.entries(project.metrics).map(([key, value]) => (
                          <span key={key} className="text-sm font-bold text-black">
                            {value}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500">No projects found in this category.</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PortfolioPage;
